<mat-sidenav-container class="example-container" [class.mobile-open]="isMobile && opened"
  [class.mobile-closed]="isMobile && !opened">
  <mat-sidenav [mode]="mode" class="sidebar" [(opened)]="opened" (openedChange)="onOpenedChange($event)"
    (keydown)="preventEscClose($event)" tabindex="0" [fixedInViewport]="isMobile">
    <div class="sidebar-header"
      style="display: flex; justify-content: center; align-items: center; padding-right: 15px; position: relative;">
      <h6 class="logo" (click)="GoToDashboard()" [ngClass]="{ active: tripType == 'dashboard' }"
        style="margin-bottom: 0; margin-top: 5px;">
        S9
      </h6>
      <div class="sidebar-close-btn" *ngIf="isMobile" (click)="toggleSidebar()"
        style="cursor: pointer; margin-top: 20px; position: absolute; right: 15px;">
        <svg viewBox="0 0 100 80" width="25" height="25" style="fill: #f58634;">
          <rect width="100" height="15" rx="8"></rect>
          <rect y="30" width="100" height="15" rx="8"></rect>
          <rect y="60" width="100" height="15" rx="8"></rect>
        </svg>
      </div>
    </div>
    <div class="truck-sidenav" style="margin-top: 10px;">
      <div *ngIf="hasPermission('dashboard')" [ngClass]="{ active: tripType == 'dashboard' }" class="truck-sidenav-menu"
        (click)="getTripsList('dashboard')">
        <h2 (click)="getTripsList('dashboard')">Dashboard</h2>
      </div>


      <div *ngIf="hasPermission('vendors')" [ngClass]="{ active: tripType == 'vendors' }" class="truck-sidenav-menu"
        (click)="getTripsList('vendors')">
        <h2 (click)="getTripsList('vendors')">Vendors</h2>
      </div>


      <div *ngIf="hasPermission('trucks')" [ngClass]="{ active: tripType === 'trucks' }" class="truck-sidenav-menu">
        <ul class="list-group">
          <a href="#submenu1" data-toggle="collapse" aria-expanded="false"
            class="list-group-item list-group-item-action flex-column align-items-start" id="trucksDropdown"
            (click)="getTripsList('trucks')">
            <div class="d-flex w-100 justify-content-center align-items-center" (click)="getTripsList('trucks')">
              <span class="menu-collapsed">Trucks</span>
            </div>
          </a>
          <div #submenu1 id="submenu1" class="collapse sidebar-submenu">
            <a class="list-group-item list-group-item-action" routerLink="/admin/trucks"
              routerLinkActive="router-link-active">
              <span class="menu-collapsed">Trucks</span>
            </a>
            <a class="list-group-item list-group-item-action" routerLink="/admin/truck-category"
              routerLinkActive="router-link-active">
              <span class="menu-collapsed">Trucks Category</span>
            </a>
            <a class="list-group-item list-group-item-action" routerLink="/admin/truck-type">
              <span class="menu-collapsed">Trucks Type</span>
            </a>
          </div>
        </ul>
      </div>

      <div *ngIf="hasPermission('loads')" [ngClass]="{ active: tripType == 'loads' }" class="truck-sidenav-menu"
        (click)="getTripsList('loads')">
        <h2 (click)="getTripsList('loads')">Loads</h2>
      </div>
      <div *ngIf="hasPermission('drivers')" [ngClass]="{ active: tripType == 'drivers' }" class="truck-sidenav-menu"
        (click)="getTripsList('drivers')">
        <h2 (click)="getTripsList('drivers')">Drivers</h2>
      </div>
      <div *ngIf="hasPermission('mapping')" [ngClass]="{ active: tripType == 'mapping' }" class="truck-sidenav-menu"
        (click)="getTripsList('mapping')">
        <h2 (click)="getTripsList('mapping')">Mapping</h2>
      </div>
      <div *ngIf="hasPermission('driverOrders')" [ngClass]="{ active: tripType == 'driverOrders' }"
        class="truck-sidenav-menu" (click)="getTripsList('driverOrders')">
        <h2 (click)="getTripsList('driverOrders')">Driver Orders (Route)</h2>
      </div>
      <div *ngIf="hasPermission('tax')" [ngClass]="{ active: tripType == 'tax' }" class="truck-sidenav-menu"
        (click)="getTripsList('tax')">
        <h2 (click)="getTripsList('tax')">Tax</h2>
      </div>
      <!-- <div
        [ngClass]="{ active: tripType == 'gpsType' }"
        class="truck-sidenav-menu"
        (click)="getTripsList('gpsType')"
        
        
      >
        <h2 (click)="getTripsList('gpsType')">GPS Type</h2>
      </div> -->
      <!-- <div
        [ngClass]="{ active: tripType == 'gps' }"
        class="truck-sidenav-menu"
        (click)="getTripsList('gps')"
        
        
      >
        <h2 (click)="getTripsList('gps')">GPS</h2>
      </div> -->
      <div *ngIf="hasPermission('pre_orders')" [ngClass]="{ active: tripType == 'pre_orders' }"
        class="truck-sidenav-menu" (click)="getTripsList('pre_orders')">
        <h2 (click)="getTripsList('pre_orders')">Pre Orders</h2>
      </div>
      <div *ngIf="hasPermission('documents')" [ngClass]="{ active: tripType == 'documents' }" class="truck-sidenav-menu"
        (click)="getTripsList('documents')">
        <h2 (click)="getTripsList('documents')">Documents</h2>
      </div>
      <div *ngIf="hasPermission('trips')" [ngClass]="{ active: tripType == 'trips' }" class="truck-sidenav-menu"
        (click)="getTripsList('trips')">
        <h2 (click)="getTripsList('trips')">Trips</h2>
      </div>
      <div *ngIf="hasPermission('workorder')" [ngClass]="{ active: tripType == 'workorder' }" class="truck-sidenav-menu"
        (click)="getTripsList('workorder')">
        <h2 (click)="getTripsList('workorder')">Work Orders</h2>
      </div>
      <div *ngIf="hasPermission('payments')" [ngClass]="{ active: tripType == 'payments' }" class="truck-sidenav-menu"
        (click)="getTripsList('payments')">
        <h2 (click)="getTripsList('payments')">Payments</h2>
      </div>
      <div *ngIf="hasPermission('reports')" [ngClass]="{ active: tripType == 'reports' }" class="truck-sidenav-menu"
        (click)="getTripsList('reports')">
        <h2 (click)="getTripsList('reports')">Reports</h2>
      </div>
      <div *ngIf="hasPermission('invoice')" [ngClass]="{ active: tripType == 'invoice' }" class="truck-sidenav-menu"
        (click)="getTripsList('invoice')">
        <h2 (click)="getTripsList('invoice')">Invoices</h2>
      </div>
      <div *ngIf="hasPermission('track')" [ngClass]="{ active: tripType == 'track' }" class="truck-sidenav-menu"
        (click)="getTripsList('track')">
        <h2 (click)="getTripsList('track')">Track</h2>
      </div>
      <div *ngIf="hasPermission('track')" [ngClass]="{ active: tripType == 'track-new' }" class="truck-sidenav-menu"
        (click)="getTripsList('track-new')">
        <h2 (click)="getTripsList('track-new')">Track New (MapLibre)</h2>
      </div>
      <div *ngIf="hasPermission('users')" [ngClass]="{ active: tripType == 'users' }" class="truck-sidenav-menu"
        (click)="getTripsList('users')">
        <h2 (click)="getTripsList('users')">Users</h2>
      </div>
      <div *ngIf="hasPermission('promotional_notifications')" [ngClass]="{ active: tripType == 'promotional_notifications' }" class="truck-sidenav-menu"
        (click)="getTripsList('promotional_notifications')">
        <h2 (click)="getTripsList('promotional_notifications')">Promotional Notifications</h2>
      </div>
      <div *ngIf="hasPermission('settings')" [ngClass]="{ active: tripType == 'settings' }" class="truck-sidenav-menu"
        (click)="getTripsList('settings')">
        <h2 (click)="getTripsList('settings')">Settings</h2>
      </div>
      <div *ngIf="hasPermission('web')" [ngClass]="{ active: tripType == 'web' }" class="truck-sidenav-menu"
        (click)="getTripsList('web')">
        <h2 (click)="getTripsList('web')">Web Pages</h2>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="mainContent">
    <div class="row m-0">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>